module.exports = __webpack_public_path__ + "img/home__3D——vi.540dd0b0.png";